export const ENT_TYPES = {
    SHIPPING: 'shipping',
    CATEGORY_PRODUCT: 'category_product',
    CATEGORY_PAGE: 'category_page',
    PRODUCT: 'product',
    PRODUCT_VAR: 'product_var',
    GALLERY: 'gallery',
    BRAND: 'brand',
    SETTING: 'setting',
    PAGE: 'page',
    DATA: 'data',
    SLIDESHOW: 'slideshow',
    CART: 'cart',
    SHIPPING_TYPES: 'shipping_types',
    PURCHASE_ORDER: 'purchase_order',
    PAYMENT_ORDER: 'payment_order',
    LOG: 'log'
}
export const META_TYPES = {
    ATTACHMENT: 'attachment',
    ATTR: 'attr',
    ATTR_CUSTOM: 'attr_custom'
}
export const PRODUCT_VISIBILITY = {
    VISIBLE: 'visible',
    LOGIN_ONLY: 'login_only',
    HIDDEN: 'hidden',
    UNPURCHASABLE: 'unpurchasable'
}

export const DEFAULT_CART = {
    items: [],
    totals: {
        items_discounts: 0, //item discounts
        items_total: 0, //item fees with discounts
        taxes_total: 0, //vat ...
        coupons_total: 0,
        shippings_total: 0,
        subtotal: 0, //item fees without discount
        total: 0
    },
    coupons: [],
    shipping: {}
}

export const DEFAULT_USER = {
    role: '',
    isLoggedIn: false,
    fname: '',
    lname: ''
}

export const MELLAT_RESULT_MESSAGES = {
    0: 'تراکنش موفق',
    11: 'شماره كارت نامعتبر است',
    12: 'موجودي كافي نيست',
    13: 'رمز نادرست است',
    14: 'تعداد دفعات وارد كردن رمز بيش از حد مجاز است',
    15: 'كارت نامعتبر است',
    16: 'دفعات برداشت وجه بيش از حد مجاز است',
    17: 'كاربر از انجام تراكنش منصرف شده است',
    18: 'تاريخ انقضاي كارت گذشته است',
    19: 'مبلغ برداشت وجه بيش از حد مجاز است',
    111: 'صادر كننده كارت نامعتبر است',
    112: 'خطاي سوييچ صادر كننده كارت',
    113: 'پاسخي از صادر كننده كارت دريافت نشد',
    114: 'دارنده كارت مجاز به انجام اين تراكنش نيست',
    21: 'پذيرنده نامعتبر است',
    23: 'خطاي امنيتي رخ داده است',
    24: 'اطلاعات كاربري پذيرنده نامعتبر است',
    25: 'مبلغ نامعتبر است',
    31: 'پاسخ نامعتبر است',
    32: 'فرمت اطلاعات وارد شده صحيح نمي باشد',
    33: 'حساب نامعتبر است',
    34: 'خطاي سيستمي',
    35: 'تاريخ نامعتبر است',
    41: 'شماره درخواست تكراري است',
    42: 'تراكنش Sale يافت نشد',
    43: 'قبلا درخواست Verify داده شده است',
    44: 'درخواست Verfiy يافت نشد',
    45: 'تراكنش Settle شده است',
    46: 'تراكنش Settle نشده است',
    47: 'تراكنش Settle يافت نشد',
    48: 'تراكنش Reverse شده است',
    49: 'تراكنش Refund يافت نشد',
    412: 'شناسه قبض نادرست است',
    413: 'شناسه پرداخت نادرست است',
    414: 'سازمان صادر كننده قبض نامعتبر است',
    415: 'زمان جلسه كاري به پايان رسيده است',
    416: 'خطا در ثبت اطلاعات',
    417: 'شناسه پرداخت كننده نامعتبر است',
    418: 'اشكال در تعريف اطلاعات مشتري',
    419: 'تعداد دفعات ورود اطلاعات از حد مجاز گذشته است',
    421: 'IPنامعتبر است',
    51: 'تراكنش تكراري است',
    54: 'تراكنش مرجع موجود نيست',
    55: 'تراكنش نامعتبر است',
    61: 'خطا در واريز'
}

export const PURCHASE_ORDER_STATUS_EXPLAIN = {
    0: 'در حال خرید',
    1: 'پرداخت شده',
    2: 'آماده ی ارسال',
    3: 'ارسال شد',
    4: 'تحویل شد',
    10: 'پرداخت ناموفق'
}
export const PURCHASE_ORDER_STATUS = {
    PURCHASING: 0,
    PAYED: 1,
    READY_TO_SHIP: 2,
    SHIPPED: 3,
    DELIVERED: 4,
    PAYMENT_FAILED: 10
}
export const LOG_TYPES = {
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error'
}

export * from './geo'
